export interface NavItem {
  to: string;
  label: string;
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/", label: "首页" },
  { to: "/collection/featured", label: "热门大瓜" },
  { to: "/collection/variety", label: "综艺前线" },
  { to: "/collection/stage", label: "演出舞台" },
  { to: "/about", label: "关于本站" },
];